import React from "react";

export default function SMSThuongHieuSetting({
  setRefressSearch,
  setVisibleSendSMS,
  showSMSResult,
}) {
  return <div>SMSThuongHieuSetting</div>;
}
